import React, { useState, useEffect } from "react";
import SideNavigation from "../../components/dumb/projectManager/SideNavigation";
import useAuthEffect from "../../hook/useAuthEffect";
import { useSelector } from "react-redux";
import useStatusThunk from "../../hook/useStatusThunk";
import { mapData } from "../../helpers/mapRow";
import { fetchAnalyses } from "../../redux/ducks/analysis";
import Analyses from "../../components/dumb/tables/Analyses";

const AnalysesRoute = () => {

    const analyses = useSelector(state => state.analysis.analyses);
    const [rows, setRows] = useState([]);
    const [dispatchFetchAnalyses, status] = useStatusThunk(fetchAnalyses);

    //Fetch analyses
    useAuthEffect(isAuth => dispatchFetchAnalyses());

    useEffect(() => {
        if (status == "success") setRows(mapData(analyses));
    }, [status, analyses]);

    return (
        <div className="columns-container">
            <div className="column column--sidenav">
                <SideNavigation selected="analyses" />
            </div>

            <div className="column column--primary">
                <Analyses rows={rows} />
            </div>
        </div >
    )
}

export default AnalysesRoute;